import { render, staticRenderFns } from "./OrganismField.vue?vue&type=template&id=14b67ed6&"
import script from "./OrganismField.vue?vue&type=script&lang=js&"
export * from "./OrganismField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports